import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { hooks } from '../hooks';
import { custom } from '../custom';
import { theme } from '../constants';
import { components } from '../components';
import useApi from '../customHook/useApi';
import { updateLeadProfile, viewLeadProfile } from '../environment';
import { callService } from '../customHook/callService';
import { toast } from 'react-toastify';



type Profile = {
  leadId: string | null;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: string | null;
  pref_locality_name: string | null;
  pref_locality_id: string | null;

}

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  message?: string;
}

export const ProfileEdit: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const navigate = hooks.useNavigate();


  const [formData, setFormData] = useState({
    leadId: '',
    full_name: '',
    email: '',
    phone_number: '',
    gender: '',
    dob: '',
    pref_budget_min_range: '',
    pref_budget_max_range: '',
    pref_city_name: '',
    pref_city_id: '',
    pref_locality_name: '',
    pref_locality_id: ''
  });

  const [fetchFirstLocality, setFetchFirstLocality] = useState("")

  // useEffect(() => {
  //   const storedData = sessionStorage.getItem("selectedLocalityFull");

  //   if (storedData) {
  //     try {
  //       const parsedData = JSON.parse(storedData);

  //       if (Array.isArray(parsedData) && parsedData.length > 0) {
  //         const firstLocality = parsedData[0];
  //         console.log("First locality object:", firstLocality);
  //         console.log("First locality ID:", firstLocality.locality_id);

  //         setFetchFirstLocality(String(firstLocality.locality_id));
  //       } else {
  //         console.log("No localities found in parsed data.");
  //       }
  //     } catch (error) {
  //       console.error("Error parsing sessionStorage data:", error);
  //     }
  //   } else {
  //     console.log("No 'selectedLocalityFull' found in sessionStorage.");
  //   }
  // }, []);






  const formatDateForInput = (dob: string | null): string => {
    if (!dob || typeof dob !== 'string') return '';

    const delimiter = dob.includes('/') ? '/' : '-';
    const [part1, part2, part3] = dob.split(delimiter);
    if (!part1 || !part2 || !part3) return '';

    return `${part3}-${part2.padStart(2, '0')}-${part1.padStart(2, '0')}`;
  };




  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = e.target;
  //   console.log(name, "name");

  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }))
  // };


  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  //   const { name, value } = e.target;

  //   if (name === 'dob') {
  //     const [year, month, day] = value.split('-');
  //     const formattedDob = `${day}/${month}/${year}`;
  //     setFormData(prev => ({
  //       ...prev,
  //       dob: formattedDob
  //     }));
  //   } else {
  //     setFormData(prev => ({
  //       ...prev,
  //       [name]: value
  //     }));
  //   }
  // };

  const cityOptions = [
    { id: 1, key: "Delhi" },
    { id: 2, key: "Noida" },
    { id: 3, key: "Gurugram" },
  ];



  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {

    // const cityOptions = [
    //   { id: 1, key: "Delhi" },
    //   { id: 2, key: "Noida" },
    //   { id: 3, key: "Gurugram" },
    // ];

    const { name, value } = e.target;

    if (name === 'pref_city_name') {
      const selectedCity = cityOptions.find(city => city.key === value);
      setFormData(prev => ({
        ...prev,
        pref_city_name: value,
        pref_city_id: selectedCity ? selectedCity.id.toString() : '',
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  // UPDATE PROFILE API 
  const {
    data: UpdateProfileData,
    loading: UpdateProfileLoading,
    callApi: updatePayload,
  } = useApi<profileResponse>(updateLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    if (UpdateProfileData?.success) {
      console.log("Profile updated successfully");
      // Optionally show toast/snackbar/redirect
      toast.success("Profile updated successfully");
    }
  }, [UpdateProfileData]);



  // Lead api Call
  useEffect(() => {
    const fetchViewProfile = async () => {
      try {
        const response = await callService("VIEW_PROFILE");
        console.log("✅ VIEW_PROFILE success:", response);
      } catch (error) {
        console.error("❌ VIEW_PROFILE failed:", error);
      }
    };
    fetchViewProfile();
  }, []);



  // View Profile API CALL
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });


  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id");
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  // 2. Populate formData when API response arrives
  useEffect(() => {
    if (profileData?.data) {
      const data = profileData.data;
      console.log("Setting formData:", data);

      const lead_profile_id = localStorage.getItem("lead_profile_id")
      setFormData({
        leadId: lead_profile_id ?? '',
        full_name: data.full_name ?? '',
        email: data.email ?? '',
        phone_number: data.phone_number ?? '',
        gender: data.gender ?? '',
        dob: data.dob || '',
        pref_budget_min_range: String(data.pref_budget_min_range ?? ''),
        pref_budget_max_range: String(data.pref_budget_max_range ?? ''),
        pref_city_name: data.pref_city_name ?? '',
        pref_city_id: data.pref_city_id ?? '',
        pref_locality_name: data.pref_locality_name ?? '',
        pref_locality_id: data.pref_locality_id ?? '',
      });
    }


  }, [profileData]); // ✅ Dependency is profileData




  // update from storage
  useEffect(() => {
    const storedData = sessionStorage.getItem("selectedLocalityFull");
    const selectedCity = sessionStorage.getItem("selectedCity");
    const maxAmount = sessionStorage.getItem("maxAmount");
    const minAmount = sessionStorage.getItem("minAmount");
    const gender = sessionStorage.getItem("genderAPI");

    let firstLocalityId = '';
    let firstLocalityName = '';

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        if (Array.isArray(parsedData) && parsedData.length > 0) {
          const firstLocality = parsedData[0];
          firstLocalityId = String(firstLocality.locality_id);
          firstLocalityName = firstLocality.locality_name;
          setFetchFirstLocality(firstLocalityId);
          console.log("First locality object:", firstLocality);
        }
      } catch (error) {
        console.error("Error parsing 'selectedLocalityFull':", error);
      }
    }

    // Set all these into formData state
    setFormData((prev) => ({
      ...prev,
      gender: gender || '',
      pref_city_name: selectedCity || '',
      pref_budget_max_range: maxAmount || '',
      pref_budget_min_range: minAmount || '',
      pref_locality_id: firstLocalityId || '',
      pref_locality_name: firstLocalityName || '',
    }));
  }, [profileData]);





  useEffect(() => {
    if (UpdateProfileData) {
      // Optionally check for a success flag here if your API returns one
      console.log("Update successful, now fetching updated profile...");
      fetchProfile({ leadId: formData.leadId }); // or whatever payload `viewLeadProfile` needs
    }
  }, [UpdateProfileData]);


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const localityDataRaw = localStorage.getItem("selectedLocalityFull");

    // ✅ Store gender values in sessionStorage
    const genderAPI = formData.gender || "";
    let genderReadable = "";

    switch (genderAPI) {
      case "GENDER_MALE":
        genderReadable = "Male";
        break;
      case "GENDER_FEMALE":
        genderReadable = "Female";
        break;
      case "GENDER_OTHER":
        genderReadable = "Other";
        break;
      default:
        genderReadable = "";
    }

    sessionStorage.setItem("genderAPI", genderAPI);
    sessionStorage.setItem("gender", genderReadable);

    const payload = {
      leadId: formData.leadId,
      full_name: formData.full_name,
      email: formData.email,
      phone_number: formData.phone_number,
      gender: genderAPI, // this is the enum string
      dob: formData.dob, // assumed in dd/mm/yyyy format
      pref_budget_min_range: formData.pref_budget_min_range,
      pref_budget_max_range: formData.pref_budget_max_range,
      pref_city_id: Number(formData.pref_city_id),
      pref_locality_id: fetchFirstLocality, // already assumed number
    };

    console.log("Submitting Payload:", payload);
    updatePayload(payload);
  };


  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();

  //   const localityDataRaw = localStorage.getItem("selectedLocalityFull");

  //   console.log(localityDataRaw, "localityDataRaw...........");
  //   const payload = {
  //     leadId: formData.leadId,
  //     full_name: formData.full_name,
  //     email: formData.email,
  //     phone_number: formData.phone_number,
  //     gender: formData.gender,
  //     dob: formData.dob, // assumed in dd/mm/yyyy format
  //     pref_budget_min_range: formData.pref_budget_min_range,
  //     pref_budget_max_range: formData.pref_budget_max_range,
  //     pref_city_id: Number(formData.pref_city_id),
  //     // pref_locality_id: Number(firstLocalityId)
  //     pref_locality_id: fetchFirstLocality // convert to number
  //   };

  //   console.log("Submitting Payload:", payload);
  //   updatePayload(payload);

  // };




  // ***********************  Start Component  ***************************************
  const renderImageBackground = (): JSX.Element => {
    return (
      <img
        src={require('../assets/other/01.png')}
        alt='Sign In'
        style={{
          width: '100%',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: '50%',
          zIndex: -1,
          objectFit: 'cover',
          maxWidth: 650,
          transform: 'translateX(-50%)',
        }}
      />
    );
  };

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        title='Profile Edit'
        goBack={true}
        style={{ backgroundColor: theme.colors.transparent }}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    // const cityOptions = [
    //   { id: 1, key: "Delhi" },
    //   { id: 2, key: "Noida" },
    //   { id: 3, key: "Gurugram" },
    // ];

    return (
      <main style={{ paddingBottom: 0 }}>
        <form onSubmit={handleSubmit} className="form-container">
          <div className="form-group">
            <label className="form-label">Name</label>
            <input type="text" name='full_name' className="form-input" placeholder="Enter Name" value={formData.full_name} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input type="email" name='email' className="form-input" placeholder="Enter Email" value={formData.email} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label className="form-label">Phone Number</label>
            <input disabled type="text" name='phone_number' className="form-input" placeholder="Enter Phone number" maxLength={10} value={formData.phone_number} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label className="form-label">Gender</label>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="GENDER_MALE"
                  checked={formData.gender == "GENDER_MALE"}
                  onChange={handleChange}
                />
                <span>Male</span>
              </label>
              <label>
                <input
                  type="radio"
                  name="gender"
                  value="GENDER_FEMALE"
                  checked={formData.gender == "GENDER_FEMALE"}
                  onChange={handleChange}
                />
                <span>Female</span>
              </label>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Date of Birth</label>
            <input
              type="date"
              className="form-input"
              name="dob"
              // value={formatDateForInput(formData.dob)}
              value={formData.dob}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Min Budget Preference</label>
            <input type="number" name="pref_budget_min_range" className="form-input" placeholder="Enter Min Budget" value={formData.pref_budget_min_range} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label className="form-label">Max Budget Preference</label>
            <input type="number" name="pref_budget_max_range" className="form-input" placeholder="Enter Max Budget" value={formData.pref_budget_max_range} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label className="form-label">Preferred City</label>
            <select
              name="pref_city_name"
              className="form-input"
              value={formData.pref_city_name}
              onChange={handleChange}
            >
              <option value="">Select City</option>
              {cityOptions.map((city) => (
                <option key={city.id} value={city.key}>
                  {city.key}
                </option>
              ))}
            </select>
          </div>


          <div className="form-group">
            <label className="form-label">Preferred Locality</label>
            <input disabled type="text" name="pref_city_name" className="form-input" placeholder="Enter Preferred City" value={formData.pref_locality_name} onChange={handleChange} />
          </div>

          <div style={{ display: "flex", justifyContent: "right" }}>
            <button className="form-button" type="submit" disabled={UpdateProfileLoading}>
              {UpdateProfileLoading ? "Updating..." : "Update Profile"}
            </button>
          </div>
        </form>



      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};










// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { hooks } from '../hooks';
// import { custom } from '../custom';
// import { theme } from '../constants';
// import { components } from '../components';

// export const ProfileEdit: React.FC = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };

//     scrollToTop();
//   }, [pathname]);

//   const navigate = hooks.useNavigate();

//   const renderImageBackground = (): JSX.Element => {
//     return (
//       <img
//         src={require('../assets/other/01.png')}
//         alt='Sign In'
//         style={{
//           width: '100%',
//           height: '100vh',
//           position: 'fixed',
//           top: 0,
//           left: '50%',
//           zIndex: -1,
//           objectFit: 'cover',
//           maxWidth: 650,
//           transform: 'translateX(-50%)',
//         }}
//       />
//     );
//   };

//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         title='Profile Edit'
//         goBack={true}
//         style={{ backgroundColor: theme.colors.transparent }}
//       />
//     );
//   };

//   const renderContent = (): JSX.Element => {
//     return (
//       <main style={{ paddingBottom: 0 }}>
//         <div
//           style={{
//             width: '32%',
//             margin: '0 auto',
//             marginBottom: '10%',
//             marginTop: '6%',
//             position: 'relative',
//             cursor: 'pointer',
//             userSelect: 'none',
//           }}
//           onClick={() => { }}
//         >
//           <img
//             src='https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo='
//             alt='Profile'
//             style={{ width: '100%', height: 'auto', borderRadius: '50%' }}
//           />
//           <img
//             src={require('../assets/other/05.png')}
//             alt='camera'
//             style={{
//               position: 'absolute',
//               right: 0,
//               bottom: 0,
//               width: '30%',
//               height: 'auto',
//             }}
//           />
//         </div>
//         <div className='container'>
//           <custom.InputField
//             label='Name'
//             placeholder='Kristin Watson'
//             containerStyle={{ marginBottom: 10 }}
//           />
//           <custom.InputField
//             label='Email'
//             placeholder='kristinwatson@mail.com'
//             containerStyle={{ marginBottom: 10 }}
//           />
//           <custom.InputField
//             label='Phone number'
//             placeholder='+17 123456789'
//             containerStyle={{ marginBottom: 10 }}
//             maxLength={10}
//             type='number'
//           />
//           <custom.InputField
//             label='Location'
//             placeholder='Chicago, USA'
//             containerStyle={{ marginBottom: 20 }}
//           />
//           <components.Button
//             title='Save changes'
//             style={{ marginBottom: 20 }}
//             onClick={() => {
//               navigate(-1);
//             }}
//           />
//         </div>

//       </main>
//     );
//   };

//   return (
//     <>

//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };
